var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultyArrs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-pathy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27521",
    "data-name": "Rectangle 27521",
    width: 11,
    height: 11,
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_458",
    "data-name": "Mask Group 458",
    clipPath: "url(#clip-pathy)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_98_",
    "data-name": "svgexport-6 (98)",
    transform: "translate(0 0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10797",
    "data-name": "Group 10797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10796",
    "data-name": "Group 10796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10700",
    "data-name": "Path 10700",
    d: "M10.172,4.6,5.834.258A.876.876,0,0,0,4.595,1.5L8.313,5.215,4.595,8.932a.876.876,0,1,0,1.239,1.239l4.338-4.338A.875.875,0,0,0,10.172,4.6ZM4.956,4.333,1.512.7A.854.854,0,0,0,.26.7a.969.969,0,0,0,0,1.32l2.818,2.97L.26,7.962a.969.969,0,0,0,0,1.32.854.854,0,0,0,1.253,0l3.444-3.63A.969.969,0,0,0,4.956,4.333Z",
    transform: "translate(0 -0.001)",
    fill: "#7e59d1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultyArrs);
export default __webpack_public_path__ + "static/media/multyArrs.3b797173764200a7b120a1c5ace9d4b0.svg";
export { ForwardRef as ReactComponent };